<template>
  <el-dialog
      v-loading="loading"
      :fullscreen="false"
      :close-on-press-escape="true"
      :show-close="false"
      :close-on-click-modal="false"
      class="cancel-request-dialog"
      :visible.sync="visible">
    <div class="cancel-request-header">
      <div class="cancel-order">
        Cancel Order
      </div>
      <button
          type="button"
          class="el-dialog__headerbtn"
          aria-label="Close"
          @click="$emit('update:visible', false)">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
    </div>
    <div style="border: 1px solid #DEE5EC;"></div>

    <div class="cancel-request-body">
      <div class="warning-img">
        <img
            src="../../../../assets/warning-icon.svg"
            style="height: 48px; width: 100%; padding: 6px 0px 6px 4px;">
      </div>
      <div
          class="order-number-1"
          style="padding: 0px !important;">
        Cancel Order #{{ order.order.displayable_order_id || order.order.order_id }}?
      </div>
      <div
          class="cancel-order-description"
          style="padding: 0px !important;">
        This will stop the order and refund the customer using their original payment method.<br> <br>This cannot be undone.
      </div>
    </div>

    <div style="padding: 16px 40px 24px 40px;">
      <div
          class="flex flex-row cancel-order-buttons">
        <div style="width: 50%;">
          <el-button
              style="  border: 1px solid #d4231a;  border-radius: 8px;  color: #d4231a;"
              class="keep-order-button"
              aria-label="Close"
              @click="$emit('update:visible', false)">
            Keep Order
          </el-button>
        </div>
        <div style="width: 50%;">
          <el-button
              style="background: #d4231a; border-radius: 8px;  color: #ffffff;"
              class="cancel-order-button"
              @click="cancel_order">
            Cancel Order
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { faExclamationTriangle } from "@fortawesome/fontawesome-free-solid";
import axios from "axios";

export default {
  name: "FullOrderCancelDialog",
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    warningIcon() {
      return faExclamationTriangle;
    },
  },

  mounted() {
    this.loading = false;
  },
  methods: {
    cancel_order() {
      this.displayFinalStep = true;
      axios
        .post(`/v3/cancel/cancel_order`, {
          order_id: this.order.order.displayable_order_id,
        })
        .then((response) => {
          console.log(response);
          this.$emit("update:visible", false);
          this.$emit("exit-cancel-order", true);
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>

<style>
.cancel-request-header {
  /* Modal Header */
  width: 100%;
  height: 56px;
  background: #ffffff;
  border-radius: 4px 4px 0px 0px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  .cancel-order {
    position: absolute;
    width: 86px;
    height: 24px;
    left: calc(50% - 86px / 2);
    top: 16px;
    font-family: "Equip";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #424242;
  }
}

.cancel-request-body {
  padding-right: 40px;
  padding-left: 40px;
  position: relative;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  height: 244px;
  background: #ffffff;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;

  .warning-img {
    margin-top: 12px;
    margin-bottom: 4px;
    flex-direction: column;
    align-self: flex-start;
    display: flex;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
  .order-number-1 {
    margin-top: 4px;
    margin-bottom: 4px;
    height: 36px;
    font-family: "Equip";
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    color: #424242;
  }
  .cancel-order-description {
    margin-top: 4px;
    margin-bottom: 24px;
    height: 96px;
    font-family: "Equip";
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 1.5;
    overflow-wrap: break-word;
    color: #424242;
  }
}

.cancel-order-buttons {
  .keep-order-button {
    height: 48px;
    margin-right: 8px !important;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #d4231a;
    border-radius: 8px;
    flex: none;
    order: 0;
    flex-grow: 1;
    justify-content: center;
    color: #d4231a;
    align-items: center;
    text-align: center;
    overflow-y: scroll;
  }
  .cancel-order-button {
    height: 48px;
    margin-left: 8px !important;
    background: #d4231a;
    border-radius: 8px;
    flex: none;
    order: 1;
    flex-grow: 1;
    overflow-y: scroll;
    font-family: "Equip";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
    justify-content: center;
  }
}

.keep-order-button {
  height: 48px;
  width: 50%;
  margin-right: 8px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #d4231a;
  border-radius: 8px;
  flex: none;
  order: 0;
  flex-grow: 1;
  justify-content: center;
  color: #d4231a;
  align-items: center;
  text-align: center;
  overflow-y: scroll;
}
.cancel-order-button {
  height: 48px;
  width: 50%;
  margin-left: 8px;
  background: #d4231a;
  border-radius: 8px;
  flex: none;
  order: 1;
  flex-grow: 1;
  overflow-y: scroll;
  font-family: "Equip";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  justify-content: center;
}
</style>
